import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "risa-oasis-ui_v2";
import { RootState } from "../../../redux/store/store";
import { LoaderMessage } from "../../loaderMessage/loaderMessage";
import DrugDetails from "./components/drugDetails";
import PatientDetails from "./components/patientDetails";
import { generatePatientDataForPrescription } from "./utils/generateDataForPrescription";
import { generateDrugDataForPrescription } from "./utils/generateDrugDataForPrescription";

interface PrescriptionModalProps {
  onClose: () => void;
  id: string;
}

const PrescriptionModal = (props: PrescriptionModalProps) => {
  const { data, loading, error } = useSelector(
    (state: RootState) => state.prescription,
  );
  const [patientDetails, setPatientDetails] = useState<any[]>([]);
  const [drugDetails, setDrugDetails] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      setPatientDetails(generatePatientDataForPrescription(data));
      setDrugDetails(generateDrugDataForPrescription(data));
    }
  }, [data]);

  return (
    <Modal
      dialogId={"prescription-modal"}
      onSave={props.onClose}
      title={"Patient Prescription"}
      saveButtonText={"Close"}
      cancelText={"Cancel"}
      onCancel={props.onClose}
      onClose={props.onClose}
      heightPercentage={70}
      showSingleButton={true}
      hideFooter={true}
    >
      {loading ? (
        <>
          <LoaderMessage message={"Loading prescription data..."} />
        </>
      ) : error ? (
        <>
          <div className="error-message p-4 text-red-500">
            <p>Failed to load prescription data. Please try again later.</p>
            <button
              onClick={props.onClose}
              className="mt-2 rounded bg-red-100 px-4 py-2 text-red-700"
            >
              Close
            </button>
          </div>{" "}
        </>
      ) : (
        <>
          <div className="patient-details__container">
            <PatientDetails data={patientDetails} />
          </div>
          <div className="drug-details__container mt-4">
            <DrugDetails data={drugDetails} />
          </div>
        </>
      )}
    </Modal>
  );
};

export default PrescriptionModal;
